export const recToUser = {
  total: 4,
  limit: 10,
  skip: 0,
  data: {
    staticVars: {
      'Barriers to activity': {
        value: ['Lack of access to gym, walking path, etc.'],
        updateDate: '2021-04-21T13:09:32.947Z',
        variableId: 32,
        source: '4',
        name: 'Barriers to activity',
      },
      'After dinner eating': {
        value: '26-50%',
        updateDate: '2021-04-12T11:40:13.782Z',
        variableId: 36,
        source: '4',
        name: 'After dinner eating',
      },
      'Dietary Strategies': {
        value: ['Low fat', 'Mediterranean '],
        updateDate: '2021-04-05T11:08:13.372Z',
        variableId: 38,
        source: '4',
        name: 'Dietary Strategies',
      },
      allergies: {
        value: [
          {
            name: 'Aspirin',
            source: '2',
          },
        ],
        name: 'allergies',
        variableId: 60,
      },
      diagnosis: {
        value: [
          {
            name: 'Anxiety',
            source: '4',
          },
        ],
        name: 'diagnosis',
        variableId: 55,
      },
      symptoms: {
        value: [
          {
            name: 'Symptom Free',
            source: '2',
          },
        ],
        name: 'symptoms',
        variableId: 56,
      },
      medications: {
        value: [
          {
            name: 'Ondansetron 4 Mg Po Tbdp',
            source: '2',
          },
        ],
        name: 'medications',
        variableId: 52,
      },
    },
    outputs: [
      {
        recommendationOutput: [],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [
          {
            id: 2846,
            output:
              '<p><p></p>\n<p>Your patient has identified the following about their job/schedule: <a href="https://staging.myevolve.health/global-variables/edit/12" class="wysiwyg-mention" data-mention data-value="Lifestyle schedule">Work from home</a></p>\n<p></p>\n</p>',
            role: 'Provider',
            placement: 'Lifestyle',
            createdAt: '2020-03-02T11:55:33.708Z',
            updatedAt: '2020-03-02T11:55:33.708Z',
            organizationId: null,
            recommendationId: 203,
            createdBy: null,
            updatedBy: null,
          },
        ],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [
          {
            id: 2737,
            output:
              '<p><p>Your patient had indicated engaging in regular physical activity. Congratulate your patient and encourage your patient to keep up the good work.</p>\n</p>',
            role: 'Provider',
            placement: 'Fitness',
            createdAt: '2020-03-02T02:05:02.679Z',
            updatedAt: '2020-03-02T02:05:02.679Z',
            organizationId: null,
            recommendationId: 810,
            createdBy: null,
            updatedBy: null,
          },
        ],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [],
        recommendationMdsOutputs: [
          {
            id: 2068,
            medication_output: '<p>metformin</p>\n',
            dosage_output:
              '<p><span style="background-color: rgb(255,255,255);">Before prescribing, please confirm your patient\'s medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.  </span></p>\n<p><span style="background-color: rgb(255,255,255);">Please read our </span><a href="/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-metformin-glucophage-xr&patientUserId=307" target="_blank"><span style="background-color: transparent;">practical prescribing approach for metformin</span></a><span style="background-color: transparent;">.</span></p>\n',
            indication_contraindication_output:
              '<p><strong>Metformin is recommended</strong> because the following insulin resistance conditions were reported: <a href="https://staging.myevolve.health/recommendation/564/undefined" class="wysiwyg-mention" data-mention data-value="Confirmed insulin resistant diagnosis">Lab values for long-term blood sugar (hemoglobin A1c) ≥ 5.7%, Lab values for fasting blood sugar (glucose) ≥100</a>.</p>\n<p style="text-align:start;">Metformin may also have secondary benefits for patients who:&nbsp;</p>\n<ul>\n<li style="margin-left:1.5em;">Have insulin resistance</li>\n<li style="margin-left:1.5em;">Report cravings</li>\n<li style="margin-left:1.5em;">Report night eating</li>\n</ul>\n',
            warning_output: null,
            medication_type: 1,
            createdAt: '2020-06-12T00:11:22.297Z',
            updatedAt: '2020-06-12T00:11:22.297Z',
            organizationId: null,
            recommendationId: 566,
            createdBy: null,
            updatedBy: null,
          },
        ],
        matchedConditions: [],
      },
      {
        recommendationOutput: [
          {
            id: 3241,
            output:
              '<p></p>\n<p></p>\n<p>Your patient indicated a loss of <a href="https://staging.myevolve.health/recommendation/464/undefined" class="wysiwyg-mention" data-mention data-value="Weight from high weight">20 lb</a> from the patient\'s high weight of <a href="https://staging.myevolve.health/global-variables/edit/44" class="wysiwyg-mention" data-mention data-value="highestWeight">22 lb</a> in <a href="https://staging.myevolve.health/recommendation/464/undefined" class="wysiwyg-mention" data-mention data-value="Date_HighWeightYear">2020</a>. Because your patient has already lost some weight, further weight loss might be slower/harder to achieve. Congratulate your patient on the progress and help put this in perspective. A more aggressive treatment plan might be necessary to help your patient with ongoing weight loss.</p>\n<p></p>\n<p></p>\n',
            role: 'Provider',
            placement: 'Top line',
            createdAt: '2020-06-03T15:16:14.695Z',
            updatedAt: '2020-06-03T15:16:14.695Z',
            organizationId: null,
            recommendationId: 466,
            createdBy: null,
            updatedBy: null,
          },
        ],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [
          {
            id: 2691,
            output:
              '<p><p></p>\n<p>Your patient indicated that they do eat <a href="undefined" class="wysiwyg-mention" data-mention data-value="Sugary Foods">Sweets, Fast food, Artificial sweetener in coffee, tea or other drinks, Fruit juice</a>. Educate your patient that research has shown that eating processed food and sugar-sweetened drinks can increase hunger and cause you to eat more and gain weight. Try to minimize food and drinks on this list and <a href="/learning?callbackUrl=/nutrition/posts/for-patients-eat-whole-foods&patientUserId=307" target="_blank">focus on whole foods</a> and drinks without added sugar or <a href="/learning?callbackUrl=/nutrition/posts/for-patients-artificial-sweeteners&patientUserId=307" target="_blank">sweetener</a>.</p>\n<p></p>\n</p>',
            role: 'Provider',
            placement: 'Nutrition',
            createdAt: '2020-03-02T01:11:08.518Z',
            updatedAt: '2020-03-02T01:11:08.518Z',
            organizationId: null,
            recommendationId: 382,
            createdBy: null,
            updatedBy: null,
          },
        ],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [],
        recommendationMdsOutputs: [
          {
            id: 2084,
            medication_output:
              '<p></p>\n<span class="editor-icon">\n          <span class="icon-Verified">\n            <span class="path1"></span>\n            <span class="path2"></span>\n            <span class="path3"></span>\n          </span>\n        </span>\n<p>&nbsp;&nbsp;phentermine (Adipex-P, Lomaira) *</p>\n',
            dosage_output:
              '<p><span style="background-color: rgb(255,255,255);">* Benzphetamine, diethylpropion and phendimetrazine are other sympathomimetic amines also available in the United States, but data on these agents are minimal, and they are prescribed much less frequently.</span>&nbsp;</p>\n<p style="text-align:start;"><span style="background-color: rgb(255,255,255);">Before prescribing, please confirm your patient\'s medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.</span></p>\n<p><span style="background-color: rgb(255,255,255);">Please read our </span><a href="/learning?callbackUrl=/posts/a-practical-prescribing-approach-phentermine-adipex-lomaira&patientUserId=307" target="_blank"><span style="background-color: transparent;">practical prescribing approach for phentermine</span></a><span style="background-color: rgb(255,255,255);">.</span></p>\n',
            indication_contraindication_output:
              '<p><strong>Phentermine (Adipex-P, Lomaira) </strong><span style="color: rgb(62,62,62);"><strong>should be used with caution</strong> because your patient reports one or more of the following:</span>&nbsp;</p>\n<ul>\n<li>Over 45</li>\n<li><span style="color: rgb(62,62,62);">Insomnia – avoid evening dosing</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Anxiety</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Psychiatric care</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Kidney disease (impaired function) – </span>refer to manufacturer’s label for dosing adjustments&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Liver disease (impaired function) – </span>refer to manufacturer’s label for dosing adjustments&nbsp;</li>\n</ul>\n',
            warning_output:
              '<p></p>\n<span class="editor-icon">\n          <span class="icon-Verified">\n            <span class="path1"></span>\n            <span class="path2"></span>\n            <span class="path3"></span>\n          </span>\n        </span>\n<p>&nbsp;&nbsp;This medication has been approved for the treatment of obesity.</p>\n',
            medication_type: 2,
            createdAt: '2020-06-12T00:26:27.466Z',
            updatedAt: '2020-06-12T00:26:27.466Z',
            organizationId: null,
            recommendationId: 1086,
            createdBy: null,
            updatedBy: null,
          },
        ],
        matchedConditions: [],
      },
      {
        recommendationOutput: [
          {
            id: 2742,
            output:
              '<p><p>Educate your patient that when you lose weight, some of the weight you lose is muscle so it’s important to incorporate some strength training/resistance work to hold onto muscle. Suggest aiming for twice per week, but start with what is reasonable.</p>\n<p>Both strength training and cardiovascular activity help keep weight off in the weight maintenance phase.</p>\n<p><strong><em>Caveat: </em></strong></p>\n<p>If your patient reports that they become more hungry with exercise, suggest increasing satiating food.</p>\n</p>',
            role: 'Provider',
            placement: 'Fitness',
            createdAt: '2020-03-02T02:06:20.065Z',
            updatedAt: '2020-03-02T02:06:20.065Z',
            organizationId: null,
            recommendationId: 310,
            createdBy: null,
            updatedBy: null,
          },
        ],
        recommendationMdsOutputs: [],
        matchedConditions: [],
      },
      {
        recommendationOutput: [],
        recommendationMdsOutputs: [
          {
            id: 2094,
            medication_output:
              '<p></p>\n<span class="editor-icon">\n          <span class="icon-Verified">\n            <span class="path1"></span>\n            <span class="path2"></span>\n            <span class="path3"></span>\n          </span>\n        </span>\n<p>&nbsp;&nbsp;naltrexone SR/bupropion SR (Contrave)</p>\n',
            dosage_output:
              '<p>Before prescribing, please confirm your patient\'s medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.&nbsp;</p>\n<p>Please read our <a href="/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-naltrexone-sr-bupropion-sr-contrave&patientUserId=307" target="_blank">practical prescribing approach to naltrexone SR/bupropion SR</a> (Contrave).</p>\n',
            indication_contraindication_output:
              '<p><strong>Naltrexone SR/bupropion SR (Contrave) should be used with caution</strong> because your patient reports one or more of the following:&nbsp;</p>\n<ul>\n<li><span style="color: rgb(62,62,62);">Insomnia – avoid evening dosing</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Anxiety</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Psychiatric care</span>&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Kidney disease (impaired function) – </span>refer to manufacturer’s label for dosing adjustments&nbsp;</li>\n<li><span style="color: rgb(62,62,62);">Liver disease (impaired function) – </span>refer to manufacturer’s label for dosing adjustments&nbsp;</li>\n</ul>\n',
            warning_output:
              '<p></p>\n<span class="editor-icon">\n          <span class="icon-Verified">\n            <span class="path1"></span>\n            <span class="path2"></span>\n            <span class="path3"></span>\n          </span>\n        </span>\n<p>&nbsp;&nbsp;This medication has been approved by the FDA for the treatment of obesity.</p>\n',
            medication_type: 3,
            createdAt: '2020-06-12T00:31:47.448Z',
            updatedAt: '2020-06-12T00:31:47.448Z',
            organizationId: null,
            recommendationId: 1094,
            createdBy: null,
            updatedBy: null,
          },
        ],
        matchedConditions: [],
      },
    ],
    mdsOutputs: [
      {
        id: 1,
        medicationName: 'Metformin',
        category: 1,
        reasons: {
          caution: [],
          consider: ['The BMI of the patient is in the recommended range.'],
        },
        content: [
          "Before prescribing, please confirm your patient's medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.",
          "Please read our [practical prescribing approach for metformin](/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-metformin-glucophage-xr').",
        ],
        deletedAt: null,
        createdAt: '2022-03-24T09:37:28.967Z',
        updatedAt: '2022-03-24T09:37:28.967Z',
        createdBy: 336,
        updatedBy: 336,
        userId: 4031,
      },
      {
        id: 2,
        medicationName: 'Liraglutide',
        category: 1,
        reasons: {
          caution: [],
          consider: ['The BMI of the patient is in the recommended range.'],
        },
        content: [
          "Before prescribing, please confirm your patient's medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.",
          'Please read our [practical prescribing approach for Liraglutide 3.0 mg (Saxenda)](/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-liraglutide-saxenda) or our [practical prescribing approach for semaglutide 2.4 mg (Wegovy)](/learning?callbackUrl=/posts/a-practical-prescribing-approach-semaglutide-2-4-mg-wegovy).',
          'Liraglutide 3.0 mg (Saxenda) and semaglutide 2.4 mg (Wegovy) have been approved by the FDA for the treatment of obesity.',
        ],
        deletedAt: null,
        createdAt: '2022-03-24T09:37:28.968Z',
        updatedAt: '2022-03-24T09:37:28.968Z',
        createdBy: 336,
        updatedBy: 336,
        userId: 4031,
      },
      {
        id: 3,
        medicationName: 'Phentermine',
        category: 2,
        reasons: {
          caution: ['The patient has the diagnosis/symptom: Anxiety.'],
          consider: ['The BMI of the patient is in the recommended range.'],
        },
        content: [
          "Before prescribing, please confirm your patient's medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.",
          'Please read our [practical prescribing appraoch for phentermine/topiramate ER](/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-phentermine-topiramate-xr-qsymia)',
          'This medication has been approved by the FDA for the treatment of obesity.',
        ],
        deletedAt: null,
        createdAt: '2022-03-24T09:37:28.968Z',
        updatedAt: '2022-03-24T09:37:28.968Z',
        createdBy: 336,
        updatedBy: 336,
        userId: 4031,
      },
      {
        id: 4,
        medicationName: 'NaltrexoneSR/BupropionSR',
        category: 3,
        reasons: {
          avoid: ['The patient has the diagnosis/symptom: Anxiety.'],
        },
        content: [
          "Before prescribing, please confirm your patient's medical history aligns with this recommendation and ensure no contraindications, drug-drug interactions or allergies.",
          'Please read our [practical prescribing approach for naltrexone SR/bupropion SR](/learning?callbackUrl=/professional-resources/posts/a-practical-prescribing-approach-naltrexone-sr-bupropion-sr-contrave)',
          'This medication has been approved by the FDA for the treatment of obesity.',
        ],
        deletedAt: null,
        createdAt: '2022-03-24T09:37:28.968Z',
        updatedAt: '2022-03-24T09:37:28.968Z',
        createdBy: 336,
        updatedBy: 336,
        userId: 4031,
      },
    ],
  },
};
